export default "__VITE_ASSET__cdd3d032__"